import React from 'react';
import { Grid, TextField, MenuItem } from "@mui/material";

const categorias = [
    { value: "", label: "Todas las categorías" },
    { value: "noticias", label: "Noticias" },
    { value: "editorial", label: "Editorial" },
    { value: "estudios", label: "Estudios" },
    { value: "tendencia", label: "Tendencia" },
];

const estados = [
    { value: "", label: "Todos los estados" },
    { value: "publicado", label: "Publicado" },
    { value: "borrador", label: "Borrador" },
];

const FiltrosBlog = ({ filtroTexto, setFiltroTexto, filtroCategoria, setFiltroCategoria, filtroEstado, setFiltroEstado }) => {
    return (
        <Grid item xs={12} sm={8} md={9} lg={9} xl={9} className="alignRight" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, justifyContent: { xs: 'flex-start', sm: 'flex-end' }, alignItems: { xs: 'stretch', sm: 'center' }, width: '100%' }}>
            <TextField
                label="Buscar por título o autor"
                variant="outlined"
                value={filtroTexto}
                onChange={(e) => setFiltroTexto(e.target.value)}
                size="small"
                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 220 }, bgcolor: 'white' }}
            />
            <TextField
                select
                label="Categoría"
                value={filtroCategoria}
                onChange={(e) => setFiltroCategoria(e.target.value)}
                size="small"
                variant="outlined"
                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 180 }, bgcolor: 'white' }}
            >
                {categorias.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                select
                label="Estado"
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                size="small"
                variant="outlined"
                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 160 }, bgcolor: 'white' }}
            >
                {estados.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    );
};

export default FiltrosBlog;
